"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../../utils/documents");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _dossiers = require("../../../utils/dossiers");

var _arrays = require("../../../utils/arrays");

var _jsxRuntime = require("react/jsx-runtime");

function DossierStateResume(props) {
  if (!props.dossierState || props.dossierState.dossierState === _dossiers.DOSSIER_STATE.EMPTY) {
    return null;
  }

  function getClassByState() {
    switch (props.dossierState.dossierState) {
      case _dossiers.DOSSIER_STATE.INVALID:
        return 'invalid';

      case _dossiers.DOSSIER_STATE.WARNING:
        return 'valid';

      case _dossiers.DOSSIER_STATE.VALID:
        return 'valid';

      case _dossiers.DOSSIER_STATE.AWAITING_VERIFICATION:
        return 'invalid';

      default:
        // eslint-disable-next-line no-console
        console.error("The state \"".concat(props.dossierState.dossierState, "\" is not recognized"));
        return '';
    }
  }

  function getDownloadButton() {
    if (props.dossierState.dossierState === _dossiers.DOSSIER_STATE.EMPTY) {
      return null;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      "data-id": "dossier-state-resume-download",
      className: "secondary small inline-container",
      onClick: function onClick() {
        return props.onDownloadDossierOverview();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.dossierResume.download"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "download"
      })]
    });
  }

  function renderInvalidDocumentsInProgress(invalidDocumentsInProgress) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: !(0, _arrays.isEmpty)(invalidDocumentsInProgress) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "quitus-section",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.dossierResume.".concat(invalidDocumentsInProgress.length > 1 ? 'documentsInvalidsInProgressText' : 'documentInvalidInProgressText')
        })
      })
    });
  }

  function renderAlmostExpiredDocuments(almostExpiredDocuments) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: !(0, _arrays.isEmpty)(almostExpiredDocuments) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "quitus-section",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.dossierResume.".concat(almostExpiredDocuments.length > 1 ? 'documentsAlmostExpiredText' : 'documentAlmostExpiredText')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: "mt-2",
          children: almostExpiredDocuments.map(function (almostExpiredDocument) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "clickable dark",
                onClick: function onClick() {
                  return props.onClickDocument(almostExpiredDocument);
                },
                children: almostExpiredDocument.type.name
              })
            }, "dossier-resume-almost-expired-".concat(almostExpiredDocument.uid));
          })
        })]
      })
    });
  }

  function renderInvalidDocumentsToDo(invalidDocumentsToDo) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: !(0, _arrays.isEmpty)(invalidDocumentsToDo) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "quitus-section",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.dossierResume.".concat(invalidDocumentsToDo.length > 1 ? 'documentsInvalidsText' : 'documentInvalidText')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: "mt-2",
          children: invalidDocumentsToDo.map(function (invalidDocument) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "clickable dark",
                onClick: function onClick() {
                  return props.onClickDocument(invalidDocument);
                },
                children: invalidDocument.type.name
              })
            }, "dossier-resume-invalid-".concat(invalidDocument.uid));
          })
        })]
      })
    });
  }

  function getContent() {
    var invalidDocumentsToDo = props.dossierState.invalidDocuments.filter(function (document) {
      return [_documents.DOCUMENT_STATE.MISSING, _documents.DOCUMENT_STATE.EXPIRED, _documents.DOCUMENT_STATE.REJECTED, _documents.DOCUMENT_STATE.AWAITING_SIGNATURE].includes(document.state);
    });
    var invalidDocumentsInProgress = props.dossierState.invalidDocuments.filter(function (document) {
      return [_documents.DOCUMENT_STATE.AWAITING_GATHERING, _documents.DOCUMENT_STATE.AWAITING_VALIDATION].includes(document.state);
    });
    var almostExpiredDocuments = props.dossierState.almostExpiredDocuments;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "col-12",
      children: [renderInvalidDocumentsToDo(invalidDocumentsToDo), renderAlmostExpiredDocuments(almostExpiredDocuments), renderInvalidDocumentsInProgress(invalidDocumentsInProgress)]
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "quitus-state ".concat(getClassByState()),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
      className: "col-12 flex-container space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.dossierResume.title.".concat(props.dossierState.dossierState)
      }), getDownloadButton()]
    }), getContent()]
  });
}

DossierStateResume.propTypes = {
  dossierState: _propTypes.default.shape({
    dossierState: _propTypes.default.string.isRequired,
    invalidDocuments: _propTypes.default.arrayOf((0, _documents.documentPropTypes)()),
    almostExpiredDocuments: _propTypes.default.arrayOf((0, _documents.documentPropTypes)())
  }),
  onDownloadDossierOverview: _propTypes.default.func.isRequired,
  onClickDocument: _propTypes.default.func.isRequired
};
var _default = DossierStateResume;
exports.default = _default;
//# sourceMappingURL=DossierStateResume.js.map